/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Immutable from 'immutable';

import Container from 'fierry/data/container';


export default class Lookup extends Container
{
  constructor (cursor, resolve)
  {
    super(cursor);

    this.resolve = resolve;
  }


  load (key, locator)
  {
    const value = Immutable.List(locator);
    const child = this.cursor.child(key);

    if (!this.has(key))
    {
      child.set(value);
    }

    else if (!value.equals(child.get()))
    {
      throw new Error(`Lookup locator changed for key: ${key}.`);
    }
  }


  at (key)
  {
    if (!this.has(key))
    {
      return null;
    }

    return this.resolve(this.cursor.child(key).get());
  }


};
